import goalUsersDialogReducer from './goalUsersDialogReducer';

export default goalUsersDialogReducer;